import React from 'react'
import { ActivityCard, ActivityCardItem } from '../../../Common/DesignSystem/ActivityCard'
import { Bar, BarChart, CartesianGrid, ResponsiveContainer, Tooltip, XAxis, YAxis } from 'recharts'
import colours from '../../../Common/DesignSystem/Colours'
import { Heading5, P3 } from '../../../Common/DesignSystem/Text'

const BookingsCard = ({
  isLoading,
  dashboardData,
  windowWidth,
  ...props
}) => {
  return (
    <div className="ds-card clickable" style={windowWidth > 768 ? { margin: 0 } : null} onClick={() => { props.history.push('/bookings') }}>
      <Heading5 style={{ marginBottom: 8 }}>Bookings</Heading5>
      <div className='flex-row mobile-col'>
        <ActivityCard
          noShadow
          label="Approved Bookings"
          iconName="Booking"
          activityCards={[
            <ActivityCardItem
              key="approved_bookings_card_item"
              loading={isLoading}
              headerValue={dashboardData?.bookingsInsights?.bookedBookings}
              labelValue="Annual Average"
              subValue={dashboardData?.annualBookingInsights?.bookedBookings}
            />
          ]}
        />
        <ActivityCard
          noShadow
          label="Avg Booking Duration"
          iconName="Calendar"
          activityCards={[
            <ActivityCardItem
              key="booking_duration_card_item"
              loading={isLoading}
              headerValue={Math.round(dashboardData?.bookingsInsights?.averageDuration) + ' days'}
              labelValue="Annual Average"
              subValue={Math.round(dashboardData?.annualBookingInsights?.averageDuration) + ' days'}
            />
          ]}
        />
        <ActivityCard
          noShadow
          label="Avg Bookings Per Location"
          iconName="Pin"
          activityCards={[
            <ActivityCardItem
              key="bookings_per_location_card_item"
              loading={isLoading}
              headerValue={Math.round(dashboardData?.bookingsInsights?.averageBookingsPerLocation)}
              labelValue="Annual Average"
              subValue={Math.round(dashboardData?.annualBookingInsights?.averageBookingsPerLocation)}
            />
          ]}
        />
      </div>
      <div style={{ marginTop: 24, display: 'flex', alignItems: 'center', flexDirection: 'column' }}>
        <P3 style={{ color: colours.primary.grey02, marginBottom: 8 }}>Monthly Bookings</P3>
        <ResponsiveContainer width={'100%'} height={340}>
          <BarChart data={dashboardData?.monthlyBookings}>
            <XAxis dataKey="name" tick={{ fontSize: '8px', fontWeight: 'bold' }} />
            <YAxis domain={[0, 'dataMax + 10']} scale="linear" tick={{ fontSize: '8px', fontWeight: 'bold' }} />
            <Tooltip formatter={(value, name, props) => [value, 'Bookings']} />
            <CartesianGrid vertical={false} stroke="#ccc" strokeDasharray='5 5' />
            <Bar barSize={16} dataKey="value" fill={colours.primary.blue} radius={[16, 16, 0, 0]} />
          </BarChart>
        </ResponsiveContainer>
      </div>
    </div>
  )
}

export default BookingsCard